module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/scott-image-409736ab45ddefaad7387b3d2201e989.jpg";